import { mapSearchApiProfilesToPublicProfiles, filterActiveCompletedProfiles } from '@/lib/utils/profile-mapper'
import { PublicProfile, PublicProfilesResponse } from '@/lib/types/public-profile'

type SearchApiSuccess<T> = {
  success: true
  data: T
  message?: string
}

type SearchApiError = {
  success?: false
  error?: string
  message?: string
  details?: any
}

type SearchApiResponse = SearchApiSuccess<{
  profiles: any[]
  pagination?: any
  filters?: any
}> | SearchApiError

export async function fetchHomepageProfiles(limit: number = 100): Promise<PublicProfilesResponse> {
  try {
    const url = new URL('/api/search/candidates', typeof window === 'undefined' ? 'http://localhost' : window.location.origin)
    url.searchParams.set('limit', String(limit))
    // Explicitly set sortBy to 'recent' for homepage profiles
    url.searchParams.set('sortBy', 'recent')

    const res = await fetch(url.toString(), { cache: 'no-store' })
    if (!res.ok) {
      const text = await res.text().catch(() => '')
      return { profiles: [], error: `Failed to load profiles (${res.status}) ${text}` }
    }
    const json: SearchApiResponse = await res.json()
    if ('success' in json && json.success) {
      const raw = (json.data?.profiles ?? []) as any[]
      console.log('[fetchHomepageProfiles] Raw profiles from API:', raw.length)
      
      // Check if Pablo is in raw data
      const pabloRaw = raw.find((p: any) => p.name === 'Pablo Garner')
      if (pabloRaw) {
        console.log('[fetchHomepageProfiles] Pablo found in raw data:', {
          name: pabloRaw.name,
          is_active: pabloRaw.is_active,
          profile_completed: pabloRaw.profile_completed,
          roles: pabloRaw.roles
        })
      } else {
        console.log('[fetchHomepageProfiles] Pablo NOT found in raw data')
      }
      
      // Defensively ensure only active and completed profiles are shown
      const filteredRaw = filterActiveCompletedProfiles(raw)
      console.log('[fetchHomepageProfiles] After filterActiveCompletedProfiles:', filteredRaw.length)
      
      const transformed = mapSearchApiProfilesToPublicProfiles(filteredRaw)
      console.log('[fetchHomepageProfiles] After transformation:', transformed.length)
      
      const filtered = transformed.filter(p => !!p)
      console.log('[fetchHomepageProfiles] Final profiles count:', filtered.length)
      
      // Check if Pablo made it through
      const pabloFinal = filtered.find(p => p.name === 'Pablo Garner')
      if (pabloFinal) {
        console.log('[fetchHomepageProfiles] Pablo in final output:', {
          name: pabloFinal.name,
          roles: pabloFinal.roles
        })
      } else {
        console.log('[fetchHomepageProfiles] Pablo NOT in final output')
      }
      
      return { profiles: filtered }
    }
    return { profiles: [], error: json.message || json.error || 'Unknown API error' }
  } catch (err: any) {
    return { profiles: [], error: err?.message || 'Unexpected error fetching profiles' }
  }
}


